import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  records: [],
  pageMeta: {},
};

export const systemEmailSlice = createSlice({
  name: 'systemEmail',
  initialState,
  reducers: {
    setEmailList(state, action) {
      state.pageMeta = action.payload.pageMeta;
      state.records = action.payload.records;
    },
  },
});

export const { setEmailList } = systemEmailSlice.actions;

export default systemEmailSlice;
